export default __webpack_public_path__ + "static/media/Ravenkin Hood.336ce801.jpg";